import protection from '../../assets/img/protection.svg';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAppLoginStatus,
    getProviderUrl,
} from '../../redux/slices/authSlice';
import { toast } from 'react-toastify';
import { ErrorText } from '../CustomInput/CustomInput';

export default function LoginForm() {
    const dispatch = useDispatch();
    const authError = useSelector(getAppLoginStatus);

    const onLogin = async () => {
        const data = {
            provider: 'GOOGLE',
        };

        try {
            const response = await dispatch(getProviderUrl(data)).unwrap();
            window.location.href = response.data.url;
        } catch (error) {
            toast.error(error.message);
        }
    };

    return (
        <div className="login__form">
            <img
                className="login__form-image"
                src={protection}
                alt="Protection"
            />
            <h2 className="login__form-title">Log in to your account</h2>
            <p className="login__form-text">
                Please login to your account using your google data
            </p>
            <Button onClick={onLogin} type="primary" size="large" block>
                Log in with Google
            </Button>
            {authError === 'failed' && (
                <ErrorText text="This server could not verify that you are authorized to access the document requested" />
            )}
        </div>
    );
}
